import debug from 'debug'

// Creates a namespaced debug logger under the 'gp:' prefix.
// Output is silent by default; enable via localStorage.debug = 'gp:*'
// (or a subsystem pattern e.g. 'gp:geo:*') in browser DevTools.
export const createDebugLogger = (namespace: string) => debug(`gp:${namespace}`)
